var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"justify-center",attrs:{"fill-height":"","fluid":""}},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":"mediumgrey","width":"2","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }